import script from "./GrupoDeBotoes.vue?vue&type=script&setup=true&lang=js"
export * from "./GrupoDeBotoes.vue?vue&type=script&setup=true&lang=js"

import "./GrupoDeBotoes.vue?vue&type=style&index=0&id=1d6c6aaf&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6c6aaf"]])

export default __exports__